import styled from "styled-components";
import { ReactNode } from "react";

type Props = {
  size: string;
  lh?: number | string;
  weight?: number | string;
  className?: string;
  as?: any;
  children: ReactNode;
};

const TextGothic = (props: Props) => {
  const { size, lh, weight, className, as = "div", children } = props;
  return (
    <Text size={size} lh={lh} weight={weight} className={className} as={as}>
      {children}
    </Text>
  );
};

const Text = styled.div<Props>`
  font-family: YakuHanJP, "Hiragino Kaku Gothic ProN", "Hiragino Sans",
    "Noto Sans JP", Meiryo, sans-serif;
  font-size: ${(props) => props.size};
  line-height: ${(props) => props.lh || 1.5};
  font-weight: ${(props) => props.weight || 700};
`;

export default TextGothic;
